<template>
	<div>
		<navpage ref="navPage" :middle="true" pagename="panelsmiddle"></navpage>

		<div id="content-page">
			<div class="row dynvibeRow">
				<div class="col-lg-12">
					<button class="dynvibeButton dynvibeBtnNavig">
						<a href="/createPanel">Add new panel</a>
					</button>
				</div>
			</div>
			<div class="row">
				<div class="col-lg-12">
					<p>Total : {{ totalPanels }}</p>
				</div>
			</div>
			<div class="row">
				<div class="col-lg-12">
					<table class="table table-striped dynvibeTable" id="refresh_table_panels">
						<thead style="width: 100%">
							<tr>
								<th class="col-xs-5">Panel</th>
								<th class="col-xs-2">Actions</th>
							</tr>
						</thead>
						<tbody style="overflow-y: unset">
							<tr v-for="panel in panels" class="col-xs-12" :key="panel._id">
								<td class="col-xs-5">
									{{ panel._source.label }}
								</td>
								<td class="col-xs-2">
									<a :href="encodeURI('createPanel?panelName=' + panel._source.label)">
										<span
											data-action="Edit"
											:data-value="panel._id"
											class="dynvibeTableActions dynvibeTableActionsEdit dynvibeModalAuthor"
											title="Edit"
											style="display: inline"
											><i class="far fa-edit"></i
										></span>
									</a>
									<span
										class="dynvibeTableActions"
										@click="deleteMiddlePanel(panel._source.label)"
										data-type="panel"
										:id="panel._id"
										:data-label="panel._source.label"
										style="cursor: pointer; display: inline-block; margin-right: 15px"
										title="Delete"
										><i class="fas fa-trash-alt"></i
									></span>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
			<confirm ref="deletepanel" color="red" title="Delete" @answerconfirm="treatConfirm($event)">
				<template v-slot:confirm-body>Are you sure to delete the panel {{ panelToDelete }} ?</template>
			</confirm>
			<confirm ref="confirm" :color="confirmColor" :title="confirmTitle" :type="confirmType">
				<template v-slot:confirm-body>{{ confirmMessage }}</template>
			</confirm>
		</div>
	</div>
</template>

<script>
import navpage from "@/components/globalVue/Nav.vue";
import confirm from "@/components/globalVue/Confirm.vue";
export default {
	props: {},
	data() {
		return {
			totalPanels: 0,
			panels: "",
			panelToDelete: "",
			confirmColor: "",
			confirmTitle: "",
			confirmType: "",
			confirmMessage: "",
		};
	},
	components: {
		navpage: navpage,
		confirm: confirm,
	},
	methods: {
		loadComponent() {
			this.getData("getListPanel");
		},
		treatResponse(response) {
			this.totalPanels = response.data.totalPanels;
			this.panels = response.data.panels;
		},
		deleteMiddlePanel(label) {
			this.panelToDelete = label;
			this.$refs.deletepanel.open();
		},
		treatConfirm(response) {
			if (response === "OK") {
				this.$axios
					.get(this.$backendUrl + "deletePanels", {
						params: { label: this.panelToDelete },
						paramsSerializer: function (params) {
							return this.$Qs.stringify(params, {
								arrayFormat: "brackets",
							});
						},
					})
					.then((/*response*/) => {
						this.$refs.deletepanel.close();
						this.confirmSuccessModal(
							"The panel " + this.panelToDelete + " has been deleted. Profiles will be updated in few minutes."
						);
						this.loadComponent();
					});
			}
		},
	},
};
</script>
<style scoped></style>
